module.exports = __webpack_public_path__ + "img/flag_virginia.e70c47c7.png";